import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button, Stack, TextField, useMediaQuery, useTheme } from "@mui/material";
import CheckIcon from "@mui/icons-material/Check";
import CloseIcon from "@mui/icons-material/Close";
import { Controller, useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { object, string } from "yup";
import { PaymentFormText } from "../PaymentForm-types";
export var AddGiftCardText;
(function (AddGiftCardText) {
    AddGiftCardText["ADD_GIFT_CARD"] = "Add Gift Card";
    AddGiftCardText["ENTER_NUMBER"] = "Enter gift card number";
})(AddGiftCardText || (AddGiftCardText = {}));
export const AddGiftCardField = ({ processNewGiftCard, showTextBox, setShowTextBox, disabled, }) => {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down("sm"), { noSsr: true });
    const { control, handleSubmit, reset } = useForm({
        mode: "onSubmit",
        resolver: yupResolver(object({
            giftCardNumber: string().required(PaymentFormText.GIFT_CARD_NUMBER_REQUIRED),
        })),
    });
    const onSubmit = (data) => {
        processNewGiftCard(data.giftCardNumber);
        setShowTextBox(false);
        reset();
    };
    if (!showTextBox) {
        return (_jsx(Button, Object.assign({ disabled: disabled, fullWidth: isMobile, id: "AddGiftCard-Button", color: "primary", variant: "contained", sx: { whiteSpace: "nowrap" }, onClick: () => setShowTextBox(true) }, { children: AddGiftCardText.ADD_GIFT_CARD })));
    }
    else {
        return (_jsx("form", Object.assign({ onSubmit: handleSubmit(onSubmit) }, { children: _jsxs(Stack, Object.assign({ direction: isMobile ? "column" : "row", spacing: 1, alignItems: "flex-start", sx: isMobile ? { width: "100%", marginTop: theme.spacing(1) } : {} }, { children: [_jsx(Controller, { name: "giftCardNumber", control: control, defaultValue: "", render: ({ field, fieldState: { error } }) => (_jsx(TextField, Object.assign({ id: "AddGiftCard-Text", label: AddGiftCardText.ENTER_NUMBER, variant: "outlined", size: "small", sx: { minWidth: !isMobile ? "50%" : "" }, fullWidth: isMobile, autoFocus: true, error: Boolean(error), helperText: Boolean(error) && (error === null || error === void 0 ? void 0 : error.message) }, field))) }), _jsxs(Stack, Object.assign({ direction: "row", spacing: 1, alignItems: "flex-start", sx: { width: isMobile ? "100%" : "" } }, { children: [_jsx(Button, Object.assign({ id: "AddGiftCard-Close", color: "error", variant: "contained", fullWidth: isMobile, onClick: () => setShowTextBox(false) }, { children: _jsx(CloseIcon, {}) })), _jsx(Button, Object.assign({ id: "AddGiftCard-Submit", color: "success", variant: "contained", fullWidth: isMobile, type: "submit" }, { children: _jsx(CheckIcon, {}) }))] }))] })) })));
    }
};
